module.exports = __webpack_public_path__ + "static/img/back-top.ea88c49d.png";